import React from 'react';
import { motion } from 'framer-motion';
export function PlatformLifecycle() {
  const nodes = [{
    title: 'Early Development'
  }, {
    title: 'Education'
  }, {
    title: 'Workforce and Civic Participation'
  }, {
    title: 'Civil Service and Institutional Leadership'
  }, {
    title: 'Executive Governance'
  }];
  return <section className="py-24 lg:py-32 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-456">
      <div className="max-w-4xl mx-auto text-center mb-20" data-id="element-457">
        <span className="text-xs font-semibold text-navy-light uppercase tracking-[0.2em] mb-4 block" data-id="element-458">
          Lifecycle Model
        </span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-ink-dark mb-8" data-id="element-459">
          A platform that evolves with responsibility
        </h2>
        <p className="text-lg text-ink-muted leading-relaxed" data-id="element-460">
          The SyNeural platform is designed to scale across the human lifecycle.
          At early stages, it functions as a developmental support system
          focused on emotional regulation, cooperation, self-direction, and
          foundational reasoning. In education, it expands into logic, media
          literacy, planning, and consequential thinking. In adulthood, it
          becomes an opportunity-alignment and readiness system for workforce
          development, entrepreneurship, civic participation, and public
          service. In institutional and government settings, it becomes
          increasingly rigorous, supporting civil-service modernization,
          leadership development, and executive-level readiness.
        </p>
      </div>

      {/* Desktop Timeline */}
      <div className="hidden lg:block relative mb-16 px-4" data-id="element-461">
        {/* Base Line */}
        <div className="absolute top-[22px] left-8 right-8 h-0.5 bg-line" data-id="element-462"></div>
        {/* Gradient Progress Line */}
        <div className="absolute top-[22px] left-8 right-8 h-0.5 bg-gradient-to-r from-teal via-navy-light to-navy opacity-60" data-id="element-463"></div>

        <div className="flex justify-between relative" data-id="element-464">
          {nodes.map((node, index) => <motion.div key={node.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="flex flex-col items-center w-48 text-center relative" data-id="element-465">
              {/* Node Circle */}
              <div className={`w-12 h-12 rounded-full bg-white border-4 z-10 flex items-center justify-center mb-6 shadow-sm transition-transform hover:scale-110 ${index === nodes.length - 1 ? 'border-navy' : 'border-surface-muted shadow-inner'}`} data-id="element-466">
                <div className={`w-3 h-3 rounded-full ${index === nodes.length - 1 ? 'bg-navy' : 'bg-teal'}`} data-id="element-467"></div>
              </div>

              <h3 className="text-lg font-heading font-bold text-ink-dark mb-2" data-id="element-468">
                {node.title}
              </h3>
            </motion.div>)}
        </div>
      </div>

      {/* Mobile Timeline */}
      <div className="lg:hidden relative pl-8 py-4 space-y-12 mb-12" data-id="element-469">
        <div className="absolute top-4 bottom-4 left-[23px] w-0.5 bg-gradient-to-b from-teal via-navy-light to-navy opacity-60" data-id="element-470"></div>

        {nodes.map((node, index) => <motion.div key={node.title} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="relative pl-8" data-id="element-471">
            <div className={`absolute left-[-24px] top-0 w-10 h-10 rounded-full bg-white border-4 z-10 flex items-center justify-center ${index === nodes.length - 1 ? 'border-navy' : 'border-surface-muted'}`} data-id="element-472">
              <div className={`w-2.5 h-2.5 rounded-full ${index === nodes.length - 1 ? 'bg-navy' : 'bg-teal'}`} data-id="element-473"></div>
            </div>

            <h3 className="text-lg font-heading font-bold text-ink-dark mb-1 pt-1" data-id="element-474">
              {node.title}
            </h3>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      delay: 0.4
    }} className="text-center max-w-3xl mx-auto" data-id="element-475">
        <p className="text-xl font-medium text-navy italic border-t border-line pt-8" data-id="element-476">
          The lower the level of power, the more developmental the system.{' '}
          <br className="hidden md:block" data-id="element-477" />
          The higher the level of power, the more rigorous the standard.
        </p>
      </motion.div>
    </section>;
}